import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { Layout } from './components/Layout'
import { LoginForm } from './components/LoginForm'
import { SignupForm } from './components/SignupForm'
import { Dashboard } from './components/Dashboard'
import { CampaignList } from './components/CampaignList'
import { CampaignForm } from './components/CampaignForm'
import { CommentApproval } from './components/CommentApproval'
import { AnalyticsDashboard } from './components/AnalyticsDashboard'
import { ActivityFeed } from './components/ActivityFeed'

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  return user ? <>{children}</> : <Navigate to="/login" />
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div>Loading...</div>
  }

  return !user ? <>{children}</> : <Navigate to="/dashboard" />
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Layout>
                  <LoginForm />
                </Layout>
              </PublicRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <PublicRoute>
                <Layout>
                  <SignupForm />
                </Layout>
              </PublicRoute>
            }
          />

          {/* Private routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns"
            element={
              <PrivateRoute>
                <Layout>
                  <CampaignList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/new"
            element={
              <PrivateRoute>
                <Layout>
                  <CampaignForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/campaigns/:id/edit"
            element={
              <PrivateRoute>
                <Layout>
                  <CampaignForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/comments"
            element={
              <PrivateRoute>
                <Layout>
                  <CommentApproval />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <PrivateRoute>
                <Layout>
                  <AnalyticsDashboard />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/activity"
            element={
              <PrivateRoute>
                <Layout>
                  <ActivityFeed />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App
